import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LsButtonComponent, LsModalComponent } from '@axess/ng-limestone';
import { TranslateModule } from '@ngx-translate/core';
import { HideTranslationPipe } from '@shared/pipes/hide-translation/hide-translation.pipe';
import { OverlayPortal } from '@ui/directives/overlay-portal';

@Component({
  selector: 'app-ticket-limit-per-email-address-modal',
  templateUrl: './ticket-limit-per-email-address-modal.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, HideTranslationPipe, OverlayPortal, LsModalComponent, LsButtonComponent]
})
export class TicketLimitPerEmailAddressModalComponent {
  ticketLimitPerEmail = input.required<number>();
  isModalOpen = input.required<boolean>();

  ticketOverLimitModalClosedEvent = output();

  onTicketOverLimitModalClosed($event: MouseEvent) {
    $event.stopPropagation();

    this.ticketOverLimitModalClosedEvent.emit();
  }
}
